import { render, staticRenderFns } from "./LocalDate.vue?vue&type=template&id=5fa0f442&"
import script from "./LocalDate.vue?vue&type=script&lang=js&"
export * from "./LocalDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports